import React, { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import vid1 from "../assets/images/caption-gen-img.webp";
import vid4 from "../assets/images/video-gen.webp";
import vid2 from "../assets/images/ai-image-gen.webp";
import vid3 from "../assets/images/avatar-poster.webp";

const fetchUserData = async () => {
    const authData = localStorage.getItem("auth");
    if (!authData) throw new Error("User not authenticated");

    let parsedAuth;
    try {
        parsedAuth = JSON.parse(authData);
    } catch (error) {
        throw new Error("Invalid authentication data");
    }

    const { token, id } = parsedAuth;
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-details/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.status === 200) {
        return response.data.html; 
    } else {
        throw new Error(response.data.message || "Failed to fetch data");
    }
};

const HomePage = () => {
    const queryClient = useQueryClient();
    const [currentPlan, setCurrentPlan] = useState(null); 

    const { data: user, error } = useQuery({
        queryKey: ["userData"],
        queryFn: fetchUserData,
        staleTime: Infinity, // Keep data fresh until manually invalidated
        cacheTime: Infinity, // Keep cache even after navigating away
        refetchOnWindowFocus: false, // Do not refetch on tab switch
        keepPreviousData: true,
        enabled: !!localStorage.getItem("auth"),
        onSuccess: (newData) => {
            setCurrentPlan(newData); // Store fetched data
        },
    });

    useEffect(() => {
        queryClient.invalidateQueries(["userData"]); // Fetch fresh data only on mount
    }, []);

    return (
        <>
            <Header />
            <div style={{ display: "flex" }}>
                <div
                    style={{
                        top: "0px",
                        zIndex: "101",
                        background: "white",
                        boxShadow: "0 .8rem 1rem rgba(0, 0, 0, .15)",
                        position: "fixed",
                        height: "100vh",
                    }}
                >
                    <Aside />
                </div>
                <div className="mainstylle">
                    <div className="bg-white ps-4 pe-4 rounded margintp">
                        <section className="generate-main" style={{ paddingTop: "0px" }}>
                            <div className="container pt-4 px-2">
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <h1 className="fw-bold pt-3 text-linear" style={{ fontSize: "35px" }}>
                                            Welcome to Hey Visuals
                                        </h1>
                                    </div>
                                </div>
                                <div className="row">
                                    <CardBox videoSrc={vid4} link="/videos" className="special-card" />
                                    <CardBox videoSrc={vid1} link="/captions" />
                                    <CardBox videoSrc={vid2} link="/images" />
                                    <CardBox videoSrc={vid3} link="/avatars" />
                                </div>
                            </div>
                        </section>
                    </div>
                    <div
                        style={{
                            background: "white",
                            margin: "10px 0px 40px 0px",
                            padding: "15px 20px",
                            borderRadius: "4px",
                        }}
                    >
                        {user ? (
                            <div dangerouslySetInnerHTML={{ __html: user }} />
                        ) : (
                            <div className='alert alert-success d-flex align-items-center' style={{ paddingLeft: '43px' }}>
                            Hi, User <br />
                            Your current plan is --, which means you have access to all the amazing features.
                            </div>
                        )}
                        {error && <div className="alert alert-danger">{error.message}</div>}
                    </div>

                    <Footer />
                </div>
            </div>
        </>
    );
};

const CardBox = ({ videoSrc, link, className = "" }) => (
    <div className={`col-md-3 mb-4 col-6 ${className}`}>
        <div className="card-product">
            <Link to={link}>
                <div className="card shadow gen-v-card">
                    <div className="card__image">
                        <video className="hoverVideoStop" poster={videoSrc} loop muted width="100%">
                            <source src={videoSrc} type="video/mp4" />
                            Sorry, your browser doesn't support embedded videos.
                        </video>
                    </div>
                </div>
            </Link>
        </div>
    </div>
);

export default HomePage;
